import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { http_get, http_post } from "../../utils/api_client";
import { API_ENDPOINTS } from "../../utils/endpoints";

// BL-086/087 — per-step drop-off funnel for a path, with the biggest-drop step
// highlighted and a bulk-nudge for the learners stalled there. Falls back to a
// clean empty state (Option A) when there's no path activity yet.
function DropoffFunnel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [materialId, setMaterialId] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const params = materialId ? { learning_material_id: materialId } : {};
    http_get(API_ENDPOINTS.GET_DASHBOARD_DROPOFF, params)
      .then(({ data: d }) => { if (alive) setData(d); })
      .catch(() => { if (alive) setData(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [materialId]);

  const funnel = data && data.funnel;
  const steps = (funnel && funnel.steps) || [];
  const drop = funnel && funnel.biggest_drop;
  const available = (data && data.available) || [];

  const bulkNudge = async () => {
    if (!drop || !funnel) return;
    setBusy(true);
    try {
      const { data: r } = await http_post(API_ENDPOINTS.DASHBOARD_DROPOFF_BULK_NUDGE, {
        learning_material_id: funnel.material.id,
        step_uid: drop.step_uid,
      });
      const n = r?.nudged_count ?? 0;
      toast.success(`Nudged ${n} stalled learner${n === 1 ? "" : "s"}.`);
    } catch (e) {
      toast.error("Could not send nudges.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dv-card">
      <div className="dv-head">
        <div><h3>Where learners drop off</h3></div>
        <div className="sp" />
        {available.length > 0 && funnel && (
          <select className="dv-select" value={funnel.material.id} onChange={(e) => setMaterialId(Number(e.target.value))}>
            {available.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        )}
      </div>

      {loading && !data ? (
        <div className="dv-empty">Loading…</div>
      ) : steps.length === 0 ? (
        <div className="dv-empty-state">
          <span className="dv-empty-state__ic dv-empty-state__ic--funnel" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 5h18l-7 8v5l-4 2v-7z" /></svg>
          </span>
          <div className="dv-empty-state__t">No drop-off data yet</div>
          <div className="dv-empty-state__s">As learners move through your paths, this shows where they drop off and which step leaks the most.</div>
        </div>
      ) : (
        <>
          {steps.map((s) => {
            const isDrop = drop && drop.step_uid === s.uid;
            return (
              <div className={`dv-fstep${isDrop ? " drop" : ""}`} key={s.uid}>
                <div className="top">
                  <span className="s">
                    {s.position} · {s.title}
                    {isDrop && drop.drop_pct ? <span className="dv-droptag">biggest drop &minus;{drop.drop_pct}%</span> : null}
                  </span>
                  <span className="v">{s.rate}%</span>
                </div>
                <div className="dv-ftrack"><i style={{ width: `${Math.min(s.rate, 100)}%` }} /></div>
              </div>
            );
          })}
          {drop && drop.stalled_count > 0 && (
            <div className="dv-fixlink">
              <button type="button" onClick={bulkNudge} disabled={busy}>
                {busy ? "Sending…" : `Fix this step · nudge the ${drop.stalled_count} stalled here →`}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default DropoffFunnel;
